/**
 * Ставка НДС товаров базы 1С (служба 1С, `VatDtos.cs`): сводка, предпросмотр и итог записи пачкой.
 * Числа сводки — `null`, когда база ставки не публикует: «нет данных», а не нули.
 */
export interface VatRateOption {
  code: string
  name: string
}

export interface VatCount {
  /** `null` — значение базы не сопоставилось со словарём чека или ставка не указана. */
  code: string | null
  name: string
  count: number
}

export interface VatGroup {
  key: string
  parentKey: string | null
  name: string
  total: number
  withoutVat: number
}

export interface VatSummary {
  available: boolean
  reason: string | null
  total: number | null
  withVat: number | null
  withoutVat: number | null
  markedForDeletion: number
  byRate: VatCount[]
  rates: VatRateOption[]
  groups: VatGroup[]
}

export interface VatSkip {
  reason: string
  text: string
  count: number
}

export interface VatPreview {
  rateCode: string
  rateName: string
  groupKey: string | null
  groupName: string | null
  inScope: number
  willChange: number
  alreadySet: number
  skipped: VatSkip[]
  refKeys: string[]
}

export type VatItemOutcome = 'Changed' | 'AlreadySet' | 'NotFound' | 'Failed' | 'Unknown' | 'NotProcessed'

export interface VatItemResult {
  refKey: string
  outcome: VatItemOutcome
  message: string | null
  /** Наименование и артикул — у товаров с проблемой (для отчёта). */
  name: string | null
  article: string | null
}

export interface VatApplyResult {
  changed: number
  alreadySet: number
  failed: number
  unknown: number
  notProcessed: number
  items: VatItemResult[]
}

/** Сколько товаров принимает одна пачка записи (`VatCommandLimits.Batch`). */
export const VAT_BATCH_SIZE = 50
